import React,{useState,useEffect} from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import {TextInput} from '../../components/input';
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { toast } from 'react-hot-toast';
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import SettingsMenu from '../staticscreens/SettingsMenu';
import GoBack from '../../components/back/GoBack';
import { CreateBatchesSlotService, UpdateBatchesSlotService } from '../../services/class_booking/batchesSlotServices';

function BatchesSlotCE() {

  const navigate = useNavigate()  
  const location = useLocation()
  const {state} = useLocation()

  const [data,setdata] = useState({
    start_time:'',
    end_time:'',
    sort:'',
    visibile_for_online_booking:false
  })

  useEffect(()=>{
    if(location?.pathname?.split('/')[location?.pathname?.split('/').length - 1] === 'edit'){
     setdata({...state})
    }
  },[])

  const [error,seterror] = useState({
    start_time:'',
    end_time:'',
    sort:''
  })

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }


  async function submitdata(){
    if(!data.start_time){
        seterror({...error,start_time:'This Field is required*'})
    }else if(!data.end_time){
        seterror({...error,end_time:'This Field is required*'})
    }else if(!data.sort){
        seterror({...error,sort:'This Field is required*'})
    }else{
       
        let send_data = {...data}

      
        if(location.pathname.split('/')[location.pathname.split('/').length - 1] === 'create'){
            const response = await CreateBatchesSlotService(send_data)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 201){
                toast.success("Batches Slot Created Successfully")
                resetform()
            }
        }else{
            const response = await UpdateBatchesSlotService(send_data,state?._id)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 200){
                toast.success("Batches Slot Updated Successfully")
                resetform()
                navigate(-1)
            }
        }
        
    }
  }

  function resetform(){
    setdata({
        start_time:'',
        end_time:'',
        sort:''
      })
    seterror({
        start_time:'',
        end_time:'',
        sort:''
      })
  }


  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen md:min-h-screen md:overflow-hidden'>
        <div className='md:flex'> 
         <SettingsMenu />
          <div className='px-5 md:w-full'>

          
        <div className='md:flex md:w-full md:min-h-screen md:max-h-screen md:overflow-y-scroll mb-10'>
        <div className='w-full md:border-r md:w-64 md:pr-5 md:pt-5'>
        <GoBack />  

        <h6 className='font-[700] mb-1'>Create/Edit Batches Slot</h6>
          <h6 className='text-[11px] p-2  mb-2 bg-slate-100'>Use the below form to create or update a batches slot</h6>
        



        <TextInput 
         label={'Start Time'}  
         variant="standard"
         name="start_time"
         type="time"
         error={error.start_time}
         value={data.start_time}
         handlechange={handlechange}
         placeholder="Enter your start_time"
         />


        <div className="w-full mr-1"> 
        <TextInput 
         label={'End Time'}  
         variant="standard"
         name="end_time"
         type="time"
         error={error.end_time}
         value={data.end_time}
         handlechange={handlechange}
         placeholder="Enter your end_time"
         />
        </div> 

        <div className="w-full mr-1"> 
        <TextInput 
         label={'Sort'}  
         variant="standard"
         name="sort"
         type="text"
         error={error.sort}
         value={data.sort}
         handlechange={handlechange}
         placeholder="Enter your sort"
         />
        </div> 

        <div onClick={()=>setdata({...data,visibile_for_online_booking:!data.visibile_for_online_booking})} className='flex items-center mt-2 mr-2'>
          {data?.visibile_for_online_booking ?  <BiCheckboxSquare size={22} className='text-slate-800'  />  : <BiCheckbox size={22} className='text-slate-300'  /> }
          <h6 className="text-[10px] font-[600] ml-1">Visible for Online as well as offline Booking</h6> 
        </div> 

    

         <div className='flex mt-4 pb-5'>
            <ButtonOutlinedAutoWidth btnName={'Back'} onClick={()=>{navigate(-1)}} />
            <div className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Save'} onClick={submitdata} />
            </div>
         </div>
        </div>
       
         </div>
         </div>
         </div>




    </div>
  )
}

export default BatchesSlotCE